
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import RechargeInfo from '@/shared/components/RechargeInfo.vue';
@Component({
  components: {
    'recharge-info': RechargeInfo
  }
})
export default class ConfirmModal extends Vue {
  private eventEmit = {
    eventCloseModal: 'eventCloseModal',
    eventAcceptModal: 'eventAcceptModal',
    eventOtherModal: 'eventOtherModal'
  };

  @Prop({default: false})
  private isShowModal!: boolean;

  @Prop({default: false})
  private isShowQR!: boolean;
  
  @Prop({default: 0})
  private moneyRecharge!: number;

  @Prop({default: ''})
  private content!: string;

  @Prop({default: true})
  public showNextButton!: boolean;
  
  @Prop({default: true})
  public showCloseButton!: boolean;
  
  @Prop({default: false})
  public showOtherButton!: boolean;

  @Prop({default: 'Tiếp tục'})
  public nextButtonText!: string;

  @Prop({default: 'Nạp tiền'})
  public otherButtonText!: string;

  private async created() {
    document.documentElement.style.overflow = 'hidden';
  }

  private onClose() {
      document.documentElement.style.overflow = 'auto';
      this.$emit(this.eventEmit.eventCloseModal, {
        data: null,
        close: true
      });
  }

  private onAccept() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventAcceptModal, {
        data: 'OK',
        close: true
    });
  }
  
  private onOtherAction() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventOtherModal, {
        data: 'OK',
        close: true
    });
  }
}
